import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const RateCardStructureModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=lNNpZ4aKsDY#t=42&feature=youtu.be&ab_channel=apadua" />
);

export default RateCardStructureModal;
